import { Pipe, PipeTransform, inject } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { LocalizationService } from '@myarvato/shared/localization';

@Pipe({
  name: 'localizedByteFormat',
  standalone: true,
  pure: false,
})
export class LocalizedByteFormatPipe implements PipeTransform {
  private readonly localizationService = inject(LocalizationService);

  transform(bytes: number | string | null | undefined, digits: string = '1.0-2'): string | null {
    if (bytes == null) {
      return null;
    }

    const numValue = typeof bytes === 'string' ? Number(bytes) : bytes;
    if (isNaN(numValue)) {
      return null;
    }

    let value: number;
    let unit: string;

    if (numValue < 1024) {
      value = numValue;
      unit = 'B';
    } else if (numValue < 1024 * 1024) {
      value = numValue / 1024;
      unit = 'KB';
    } else {
      value = numValue / (1024 * 1024);
      unit = 'MB';
    }

    const locale = this.localizationService.locale();
    const formatted = new DecimalPipe(locale).transform(value, digits);

    return formatted ? `${formatted} ${unit}` : null;
  }
}
